/**
 * Website color pair for light and dark mode. Like CSS `light-dark()`, which old iOS Safari (≤ 17.4) drops.
 * `--mk-l` / `--mk-d`: exactly one is empty, set in website-theme.css. CSS files write the same pair inline.
 * Dark value for a new color: `node .claude/skills/website-feature-page/scripts/dark-color.mjs <color>`.
 */
export function ld(light: string, dark: string): string {
  return `var(--mk-l, ${light}) var(--mk-d, ${dark})`;
}
